import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";

// Searchable single-select for a trade (type to search, pick one).
export function TradeCombobox({
  options = [], value = "", onChange, placeholder = "Select trade",
  searchPlaceholder = "Search trades…", testid = "trade-combobox", className = "",
}) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`${testid}-trigger`}
          role="combobox"
          aria-expanded={open}
          className={`flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 hover:border-primary/50 transition-colors ${className}`}
        >
          <span className={value ? "text-foreground truncate" : "text-muted-foreground truncate"}>
            {value || placeholder}
          </span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0 ml-2" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput data-testid={`${testid}-search`} placeholder={searchPlaceholder} />
          <CommandList>
            <CommandEmpty>No trade found.</CommandEmpty>
            <CommandGroup>
              {options.map((t) => (
                <CommandItem
                  key={t}
                  value={t}
                  data-testid={`${testid}-option-${t}`}
                  onSelect={() => { onChange(t === value ? "" : t); setOpen(false); }}
                  className="cursor-pointer"
                >
                  <Check className={`mr-2 h-4 w-4 ${t === value ? "opacity-100" : "opacity-0"}`} />
                  {t}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
